import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useCallback } from "react";
import { Card } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { CheckoutRootParamList } from "../../../../types";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { SalePayment } from "../../../../utilities/data/model/Sale";
import { makeNegative } from "../../../../utilities/make-negative";
import { SalePaymentSummary } from "../../components/SalePaymentSummary";
import { useCheckoutContextProvider } from "../../utils/checkout";

export type CheckoutPaymentHistoryScreenProps = NativeStackScreenProps<
  CheckoutRootParamList,
  "CheckoutPaymentHistoryScreen"
> & {};

export const CheckoutPaymentHistoryScreen = ({
  navigation,
}: CheckoutPaymentHistoryScreenProps) => {
  const { sale } = useCheckoutContextProvider();
  const database = useDatabase();

  const handleOnRefundClick = useCallback(
    async (payment: SalePayment) => {
      return database
        .get<PaymentMethod>("payment_methods")
        .find(payment.paymentMethodId)
        .then((i) => {
          navigation.navigate("PaymentRootScreen", {
            screen: "PaymentScreen",
            paymentMethodId: i.id,
            tenderedAmount: makeNegative(payment.amount),
          });
        })
        .catch((e) => console.log(e));
    },
    [database]
  );

  return (
    <Page>
      <Card title="Payments">
        <SalePaymentSummary sale={sale} onRefundClick={handleOnRefundClick} />
      </Card>
    </Page>
  );
};
